import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/types'
import { notifyError } from '../../utils/notify'
import oikosApi from '../../services/oikos'

function* getSectorTypes() {
  try {
    const action = 'get'
    const table = 'setor'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getSectorTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))

    yield put({ type: Types.GET_SECTOR_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_SECTOR_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de setores. Tente novamente mais tarde.')
    yield put({ type: Types.GET_SECTOR_TYPES_FAILED, payload: err })
  }
}

function* getDepartmentTypes() {
  try {
    const action = 'get'
    const table = 'dpto'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getDepartmentTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))

    yield put({ type: Types.GET_DEPARTMENT_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_DEPARTMENT_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de departamentos. Tente novamente mais tarde.')
    yield put({ type: Types.GET_DEPARTMENT_TYPES_FAILED, payload: err })
  }
}

function* getDocumentTypes() {
  try {
    const action = 'get'
    const table = 'tpDocumento'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getDocumentTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_desc`],
    }))
    console.tron.log('documentTypes', types)

    yield put({ type: Types.GET_DOCUMENT_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_DOCUMENT_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de documentos. Tente novamente mais tarde.')
    yield put({ type: Types.GET_DOCUMENT_TYPES_FAILED, payload: err })
  }
}

function* getCityTypes() {
  try {
    const action = 'get'
    const table = 'mun'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getCityTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('cityTypes', types)

    yield put({ type: Types.GET_CITY_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_CITY_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os municípios. Tente novamente mais tarde.')
    yield put({ type: Types.GET_CITY_TYPES_FAILED, payload: err })
  }
}

function* getGenderTypes() {
  try {
    const action = 'get'
    const table = 'sexo'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getGenderTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('genderTypes', types)

    yield put({ type: Types.GET_GENDER_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_GENDER_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de gêneros. Tente novamente mais tarde.')
    yield put({ type: Types.GET_GENDER_TYPES_FAILED, payload: err })
  }
}

function* getMaritalStatusTypes() {
  try {
    const action = 'get'
    const table = 'estCiv'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getMaritalStatusTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_situacao`],
    }))
    console.tron.log('maritalStatusTypes', types)

    yield put({ type: Types.GET_MARITAL_STATUS_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_MARITAL_STATUS_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de estado civil. Tente novamente mais tarde.')
    yield put({ type: Types.GET_MARITAL_STATUS_TYPES_FAILED, payload: err })
  }
}

function* getBloodTypes() {
  try {
    const action = 'get'
    const table = 'tpSangue'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getBloodTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_tipo`],
    }))
    console.tron.log('bloodTypes', types)

    yield put({ type: Types.GET_BLOOD_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_BLOOD_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos sanguíneos. Tente novamente mais tarde.')
    yield put({ type: Types.GET_BLOOD_TYPES_FAILED, payload: err })
  }
}

function* getStateTypes() {
  try {
    const action = 'get'
    const table = 'uf'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getStateTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('stateTypes', types)

    yield put({ type: Types.GET_STATE_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_STATE_TYPES_FAILED', err)
    notifyError('Não foi possível buscar as UF. Tente novamente mais tarde.')
    yield put({ type: Types.GET_STATE_TYPES_FAILED, payload: err })
  }
}

function* getLanguageTypes() {
  try {
    const action = 'get'
    const table = 'idioma'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getLanguageTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('languageTypes', types)

    yield put({ type: Types.GET_LANGUAGE_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_LANGUAGE_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de idiomas. Tente novamente mais tarde.')
    yield put({ type: Types.GET_LANGUAGE_TYPES_FAILED, payload: err })
  }
}

function* getCompanySegmentTypes() {
  try {
    const action = 'get'
    const table = 'areaAtua'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getCompanySegmentTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_area`],
    }))
    console.tron.log('companySegmentTypes', types)

    yield put({ type: Types.GET_COMPANY_SEGMENT_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_COMPANY_SEGMENT_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de áreas de atuação. Tente novamente mais tarde.')
    yield put({ type: Types.GET_COMPANY_SEGMENT_TYPES_FAILED, payload: err })
  }
}

function* getServiceGroupTypes() {
  try {
    const action = 'get'
    const table = 'gruposervico'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getServiceGroupTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('serviceGroupTypes', types)

    yield put({ type: Types.GET_SERVICE_GROUP_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_SERVICE_GROUP_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os grupos de serviços. Tente novamente mais tarde.')
    yield put({ type: Types.GET_SERVICE_GROUP_TYPES_FAILED, payload: err })
  }
}

function* getRevenueTypes() {
  try {
    const action = 'get'
    const table = 'recTp'
    let types = []

    const res = yield oikosApi.get('/', { action, table })
    console.tron.log('res getRevenueTypes', res)

    types = res.data.map(i => ({
      value: i[`${table}_id`],
      label: i[`${table}_nome`],
    }))
    console.tron.log('revenueTypes', types)

    yield put({ type: Types.GET_REVENUE_TYPES_SUCCEEDED, payload: types })
  } catch (err) {
    console.tron.log('GET_REVENUE_TYPES_FAILED', err)
    notifyError('Não foi possível buscar os tipos de receita. Tente novamente mais tarde.')
    yield put({ type: Types.GET_REVENUE_TYPES_FAILED, payload: err })
  }
}

export const typesSagas = [
  takeLatest(Types.GET_SECTOR_TYPES_REQUESTED, getSectorTypes),
  takeLatest(Types.GET_DEPARTMENT_TYPES_REQUESTED, getDepartmentTypes),
  takeLatest(Types.GET_DOCUMENT_TYPES_REQUESTED, getDocumentTypes),
  takeLatest(Types.GET_CITY_TYPES_REQUESTED, getCityTypes),
  takeLatest(Types.GET_GENDER_TYPES_REQUESTED, getGenderTypes),
  takeLatest(Types.GET_MARITAL_STATUS_TYPES_REQUESTED, getMaritalStatusTypes),
  takeLatest(Types.GET_BLOOD_TYPES_REQUESTED, getBloodTypes),
  takeLatest(Types.GET_STATE_TYPES_REQUESTED, getStateTypes),
  takeLatest(Types.GET_LANGUAGE_TYPES_REQUESTED, getLanguageTypes),
  takeLatest(Types.GET_COMPANY_SEGMENT_TYPES_REQUESTED, getCompanySegmentTypes),
  takeLatest(Types.GET_SERVICE_GROUP_TYPES_REQUESTED, getServiceGroupTypes),
  takeLatest(Types.GET_REVENUE_TYPES_REQUESTED, getRevenueTypes),
]
